import axios from 'axios';
import { Token } from './token';
import Config from '@/config';

const baseUrl = `${Config.BaseAPI}/v3/restaurant/booking`;

export default {
  /**
   * Create the restaurant reservation
   */
  createRestaurantBooking: async function(payload) {
    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.post(baseUrl, payload, { headers });
    return result.data.record;
  },

  /**
   * Update the restaurant reservation
   */
  updateRestaurantBooking: async function({ bookingId, ...payload }) {
    const url = `${baseUrl}/${bookingId}`;
    const token = await Token.getToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.patch(url, payload, { headers });
    return result.data.record;
  },

  /**
   * Cancel the restaurant reservation
   */
  cancelRestaurantBooking: async function({ bookingId, userId }) {
    const url = `${baseUrl}/${bookingId}?userId=${userId}`;
    const token = await Token.getToken();

    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.delete(url, { headers });
    return result.data.record;
  },

  /**
   * Get all restaurant reservation of specific user
   * @param {String} userId the identifier of the user
   */
  getRestaurantBooking: async function(userId) {
    const url = `${baseUrl}?userId=${userId}`;

    const token = await Token.getToken();
    const headers = {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json'
    };

    const result = await axios.get(url, { headers });
    return result.data.record;
  }
};
